<template>
  <ParseForm :formId="formId" :formParams='formParams' :emit='emit' :opCode='opCode' :reMountPage='reMountPage' 
    :funcClick ='funcClick' :funcBlur ='funcBlur' :funcOnChange ='funcOnChange' :funcKeyUp ='funcKeyUp' ref='bus'></ParseForm>
</template>

<script>
import ParseForm from '../../util/parseFormNew/ParseForm';
import bus from './bus';


export default {
  name: 'U_BaseBusiness',
  components: {
    ParseForm
  },
  props: [
    'formParams',
    'reMountPage',
    'opCode',
    'formId',
    'funcOnChange',
    'funcKeyUp',
    'funcBlur',
    'funcClick',
  ],
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    emit(attr) {
      bus.$emit('eventBus', attr);
    },
    reMount(data = null) {
      this.$refs.bus.reMount(data);
    },
    setDatas(value) {
      this.$refs.bus.setDatas(value);
    },
    // 设置表单验证
    setValidate(_name, _validate) {
      this.$refs.bus.setValidate(_name, _validate);
    },
    removeValidate(name) {
      this.$refs.bus.removeValidate(name);
    },
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      try {
        this.$refs.bus.templetCover(attr);
      } catch (e) {
      }
    });
  }
};
</script>

<style scoped>

</style>
